module.exports = __webpack_public_path__ + "img/IMG_1024_FoamcoreMatted.7f4ef97b.jpg";